import store from "@/store";
import get from "lodash/get";

export default {
  install(Vue) {
    Vue.prototype.$setup = new Vue({
      store,
      computed: {
        setup() {
          return get(this.$store, "state.setup");
        },
        config() {
          return get(this.setup, "config");
        },
        partner() {
          return get(this.setup, "partner");
        },
        theme() {
          return get(this.config, "style", "light");
        },
        partnerLogo() {
          switch (this.theme) {
            case "dark":
              return this.getPartner("logo_white");
            default:
              return this.getPartner("logo_black");
          }
        }
      },
      methods: {
        getPartner(key) {
          return get(this.partner, key);
        }
      }
    });
  }
};
